export default __webpack_public_path__ + "static/media/leader_notes.3877748a.pdf";